import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme, css } from 'styled-components';

import { Layout, Flex } from 'Components/Base';
import { withOffset } from 'Context/LayoutContext';

const HeaderWrapper = styled(Flex)`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    width: 100%;
    height: ${theme.space.CLASSROOM_NAVBAR_HEIGHT + theme.space.APP_TOP_OFFSET}px;
    padding-top: ${theme.space.APP_TOP_OFFSET}px;
    box-shadow: 0px 2px 2px rgba(232, 232, 232, 0.5);
    z-index: 2;
  `}
`;

const DashboardLayout = withTheme(({ theme, children }) => {
  return (
    <Layout
      top={
        <Fragment>
          {/* connect navbar component here and use HeaderWrapper instead of fragment*/}
        </Fragment>
      }
      topProps={{
        pb: `${theme.space.CLASSROOM_NAVBAR_HEIGHT + theme.space.APP_TOP_OFFSET}px`,
      }}
      main={children}
      bottom={<Fragment>{/* connect footer here then remove fragment which wrapped*/}</Fragment>}
      bottomProps={{ mt: 'auto' }}
      outerContainerProps={{
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        },
      }}
    />
  );
});

DashboardLayout.propTypes = {
  navbar: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
};

DashboardLayout.defaultProps = {
  navbar: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default withOffset(DashboardLayout);
